import React from 'react';
import styles from './modals.module.css'
import {createPortal} from "react-dom";
import {useDispatch, useSelector} from "react-redux";
import useEscape from "../../../helper/keypressListeners/escape";
import {getUserGuidePDFAPI} from "../../../api/userGuideAPI";
import {Document, Page} from "react-pdf";
import ZoomIcon from "../../General/icons/zoomIcon";
import OpenIcon from "../../General/icons/openIcon";
import Loading from "../../General/loading/loading";
import DownloadIcon from "../../General/icons/downloadIcon";

const PDFModal = ({closeModal, modalInformation}) => {

    const docket = useSelector((state) => state.navigation.currentDocket);
    const jwt = useSelector((state) => state.user.jwt);

    const [file, setFile] = React.useState(null)

    const clearAndCloseModal = () => {
        setFile(null)
        closeModal()
    }

    useEscape(clearAndCloseModal)

    React.useEffect(() => {

        if (modalInformation[0] === -1) {
            return
        }

        getUserGuidePDFAPI(jwt, modalInformation[0], docket).then(r => {

            const processBlob = async(resp) => {
                const blb = await resp.blob()
                setFile(blb)
            }

            processBlob(r)
        }).catch(e => {setFile(null)})
    }, [docket, jwt, modalInformation])

    return createPortal(
        <div autoFocus={false} role={'dialog'} style={{display: modalInformation[0] !== -1 ? 'flex' : 'none'}} aria-modal={true}
             aria-hidden={modalInformation[0] === -1} onClick={clearAndCloseModal}
             className={styles.wrapper} aria-describedby={'modalDescription'}>
            <div className={styles.largeContent} onClick={(event)=>{event.stopPropagation();}}>
                <div className={styles.modalDescription} id={'modalDescription'}>
                    This is a dialog window which overlays the main content of the page.
                    The modal begins with a heading called &quot;How To: {modalInformation[1]}&quot;.
                    Pressing the Close Modal button at the top will close the modal and bring you back to where you were
                    on the page.
                </div>
                <div style={{width: '100%'}}>
                    <h1 className={styles.h1}>How To: {modalInformation[1]}</h1>
                    <button className={styles.closeX} title={"Close Modal"} aria-label={"Close Modal"} autoFocus={true}
                            onClick={clearAndCloseModal}>X
                    </button>
                </div>
                <div className={styles.PDFWrapper}>
                    <div className={styles.PDFContent}>
                        {
                            file !== null ?
                            <PDFElement file={file} name={modalInformation[1]} /> :
                            <Loading />
                        }
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
};

const PDFElement = ({file, name='user_guide.pdf'}) => {

    const [numPages, setNumPages] = React.useState(null);
    const [pdfZoom, setPDFZoom] = React.useState(0.95)
    const pdfRef = React.useRef(undefined);

    function onDocumentLoadSuccess({numPages}) {
        setNumPages(numPages);
    }

    const zoomOutFunc = () => {
        let newZoom = pdfZoom
        newZoom -= 0.1
        if (newZoom < 0.4) {
            newZoom = 0.4
        }

        setPDFZoom(newZoom)
    }

    const zoomInFunc = () => {
        let newZoom = pdfZoom
        newZoom += 0.1
        if (newZoom > 2) {
            newZoom = 2
        }

        setPDFZoom(newZoom)
    }

    const downloadFile = () => {
        const blob = new Blob([file], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);

        const anchorElement = document.createElement('a');
        anchorElement.href = url;
        anchorElement.download = `insightsai_user_guide__${name.replaceAll(" ", "_").toLowerCase()}.pdf`;
        anchorElement.target = "_blank";

        anchorElement.click();
        anchorElement.remove();
        URL.revokeObjectURL(url);
    }

    let pages = []
    if (numPages != null) {
        for (let i = 1; i <= numPages; i++) {
            if (pdfRef === undefined) {
                pages.push(<Page key={i} pageNumber={i}/>)
                pages.push(<div key={`div_${i}`} style={{width: '100%', height: 16}} />)
            } else {
                pages.push(<Page key={i} pageNumber={i} width={pdfRef.current.clientWidth} scale={pdfZoom}/>)
                pages.push(<div key={`div_${i}`} style={{width: '100%', height: 16}} />)
            }

        }
    }

    if (file === null) {
        return null
    }

    return (
        <div className={styles.pdfDiv}>
            <Document inputRef={pdfRef} file={file} onLoadSuccess={onDocumentLoadSuccess}>
                {
                    pages
                }
            </Document>
            <div className={styles.zoomContainer}>
                <div className={styles.zoomBar}>
                    <button onClick={zoomInFunc} disabled={pdfZoom >= 2} className={styles.zoomButton}>
                        <ZoomIcon zoomIn={true}/>
                    </button>
                    <button onClick={zoomOutFunc} disabled={pdfZoom <= 0.4} className={styles.zoomButton}>
                        <ZoomIcon zoomIn={false}/>
                    </button>
                    <button onClick={downloadFile} className={styles.zoomButton}>
                        <DownloadIcon invert={true} />
                    </button>
                </div>
            </div>
        </div>
    )
}

export default PDFModal;